import moment from "moment";
import app, { Klass, u_ } from "@@assets/scripts/common";

const holidaysApiUrl = "https://holidays-jp.github.io/api/v1/date.json";

const holidaysModule = Klass.new_("TyrellModule", "holidays", { app });
Object.assign(holidaysModule, {
	format(data) {
		if( !u_.isObject(data) ) {
			throw new TypeError("arguments[0] must be object.");
		}
		
		const holidays = {};
		const mdMap = {};
		Object.keys(data).forEach(date => {
			const { type, name } = data[date];
			date = moment(date);
			if( !date.isValid() ) {
				return true;
			}
			
			const [year, month, day] = date.format("YYYY-M-D").split("-");
			const md = `${month}-${day}`;
			
			if(mdMap[md] && mdMap[md].name === name) {
				const item = mdMap[md];
				const y = parseInt(year);
				const minYear = parseInt(item.minYear);
				const maxYear = parseInt(item.maxYear);
				if(y - minYear === -1) {
					item.minYear = year;
				} else
				if(y - maxYear === 1) {
					item.maxYear = year;
				}
				return true;
			}
			
			Array.isArray(holidays[month]) || (holidays[month] = []);
			const item = {
				type,
				name,
				day,
				minYear: year,
				maxYear: year
			};
			
			holidays[month].push(item);
			mdMap[md] = item;
		});
		
		return holidays;
	}
});

function getHolidaysPromise(now) {
	if( !moment.isMoment(now) ) {
		throw new TypeError("arguments[0] must be instance of moment.");
	}
	
	holidaysModule.getFilter = {
		conditions: [
			{
				"targetParam": "year",
				"condition": "gte",
				"value": now.format("YYYY")
			},
			{
				"targetParam": "OR",
				"conditions": [
					{
						"targetParam": "month",
						"condition": "eq",
						"value": now.format("M")
					},
					{
						"targetParam": "month",
						"condition": "eq",
						"value": now.clone().add(1, "months").format("M")
					}
				]
			}
		]
	};
	
	return Promise.all([
		new Promise(resolve => app.getJSON(holidaysApiUrl, response => resolve(
			holidaysModule.format(response)
		))),
		new Promise(resolve => holidaysModule.loadConfig(err => {
			if(err) {
				resolve();
				return false;
			}
			
			holidaysModule.loadItems(err => {
				if(err) {
					resolve();
					return false;
				}
				
				const holidays = {};
				const { dataName } = holidaysModule.config;
				holidaysModule.items.list.forEach(item => {
					const { year, month, days, etcDays } = item;
					if(
						!year ||
						!month ||
						( !Array.isArray(days) && !Array.isArray(etcDays) )
					) {
						return true;
					}
					
					const y = u_.zeroPadding(year, 4);
					const m = u_.zeroPadding(month, 2);
					
					Array.isArray(days) && days.forEach(data => {
						const { day } = data;
						if(!day) {
							return true;
						}
						
						const d = u_.zeroPadding(day, 2);
						holidays[`${y}-${m}-${d}`] = { type: "closed", name: dataName };
					});
					
					Array.isArray(etcDays) && etcDays.forEach(data => {
						const { day, detail } = data;
						if(!day || !detail) {
							return true;
						}
						
						const d = u_.zeroPadding(day, 2);
						holidays[`${y}-${m}-${d}`] = { type: "etc", name: detail };
					});
				});
				
				resolve( holidaysModule.format(holidays) );
			});
		}))
	]);
}

export default getHolidaysPromise;
export { holidaysModule };
